var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCenterMain01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 85,
    viewBox: "0 0 70 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_478_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0475 21.839V24.0425H35.6735V21.839H35.1541C34.7402 21.839 34.3994 21.5025 34.3994 21.0938V19.8038C34.3994 19.3951 34.7402 19.0586 35.1541 19.0586H40.575C40.9888 19.0586 41.3297 19.3951 41.3297 19.8038V21.0938C41.3297 21.5025 40.9888 21.839 40.575 21.839H40.0556H40.0475Z",
    fill: "#F9EBDF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.8645,
    cy: 51.2179,
    rx: 28.1355,
    ry: 27.7804,
    fill: "#F9EBDF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.8648,
    cy: 51.2207,
    rx: 22.1011,
    ry: 21.8222,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2712 11.7266C19.5593 15.0738 16.4747 23.9365 22.8206 30.9334M6 32.4786C9.3898 32.1438 14.994 32.4786 18.0612 36.3638",
    stroke: "#F9EBDF",
    strokeWidth: 3.03784,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.5322,
    cy: 5.59323,
    rx: 3.63915,
    ry: 3.59323,
    fill: "#F9EBDF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.8869,
    cy: 51.3634,
    rx: 21.2131,
    ry: 20.9454,
    fill: "#CCA284"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0251 51.2209V30.8047C49.443 30.8047 58.7023 39.9471 58.7023 51.2209C58.7023 62.4947 49.443 71.6371 38.0251 71.6371C30.6405 71.6371 23.8076 67.743 20.1152 61.429L38.0251 51.2209Z",
    fill: "#CCA284"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_478_2",
    x: 0.480957,
    y: 0,
    width: 69.519,
    height: 85,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.713726 0 0 0 0 0.564706 0 0 0 0 0.517647 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_478_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_478_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCenterMain01);
export default __webpack_public_path__ + "static/media/icon-center-main01.c2d57530831a09857015dba5a24d0b80.svg";
export { ForwardRef as ReactComponent };